import script from "./VerifyToken.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyToken.vue?vue&type=script&setup=true&lang=js"

import "./VerifyToken.vue?vue&type=style&index=0&id=79ffefa0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ffefa0"]])

export default __exports__